import store from "../../store/store"

export const checkRef = (refType: string) => {
    const references = store?.getState().project.references.data
    return references?.some(ref => ref.type === refType && ref.value === "true") ?? false
}
